import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavLink } from "react-router-dom";

import { Page, Card, Alert, Icon } from "tabler-react";
import { SiteWrapper } from "../common";

import ReactTable from "react-table";

import { findWorkItems, findWorkItemsByAssignee } from '../actions';
import * as moment from 'moment';
import { RequisitionSettings } from './';
import { ItemListingPageTypes } from '../constants';

import Auth from '../auth/auth';

const auth = new Auth({});

class RequisitionItemPage extends Component {

  dataStoreKey = '';
  filterTimer;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      workItems: [],
      type: this.determinePageType(),
      alert: {
        display: false,
        type: '',
        icon: '',
        message: ''
      },
      page: 1,
      pageSize: 50,
      order: '',
      ascDesc: '',
      name: '',
      referenceNum: '',
      status: '',
      progress: '',
      isChecked: '',
      isLocked: '',
      assignedTo: '',
      spectators: '',
      workRequestName: '',
      workRequestReferenceNum: '',
      code: '',
      verifiedBy: '',
      submittedBy: '',
    };

    this.fetchWorkItems = this.fetchWorkItems.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onPageSizeChange = this.onPageSizeChange.bind(this);
    this.onSortedChange = this.onSortedChange.bind(this);
    this.onFilteredChange = this.onFilteredChange.bind(this);
    this.initDataStore = this.initDataStore.bind(this);

    this.dataStoreKey = `workItemDataStore_${this.state.type}`;

  }

  componentDidMount() {

    localStorage.setItem(RequisitionSettings.pagePathKey, this.props.location.pathname);

    let alert = localStorage.getItem(RequisitionSettings.alertKey);
    if (alert) {
      alert = JSON.parse(alert);
      this.setState({ alert });
      localStorage.removeItem(RequisitionSettings.alertKey);
    }

    this.initDataStore();
  }

  determinePageType() {
    return window.location.href.toString().indexOf('mine') > -1 ? ItemListingPageTypes.MY_REQUESTS
    : window.location.href.toString().indexOf('assigned') > -1 ? ItemListingPageTypes.ASSIGNED_TO_ME
    : window.location.href.toString().indexOf('view-only') > -1 ? ItemListingPageTypes.VIEW_ONLY
    : ItemListingPageTypes.ALL;
  }

  fetchWorkItems(state, instance) {
    this.setState({ loading: true });

    let { type, page, pageSize, order, ascDesc, name, referenceNum, status, progress, isChecked, isLocked, assignedTo, workRequestName, workRequestReferenceNum, code, submittedBy, verifiedBy, spectators } = this.state;

    if (type !== ItemListingPageTypes.ASSIGNED_TO_ME) {
      this.props.findWorkItems({
        page,
        pageSize,
        order,
        ascDesc,
        name: (name ? name.value : null),
        referenceNum: (referenceNum ? referenceNum.value : ''),
        status: (status ? status.value : null),
        progress: (progress ? progress.value : null),
        isChecked: (isChecked ? isChecked.value : null),
        isLocked: (isLocked ? isLocked.value : null),
        type,
        assignedTo: (assignedTo ? assignedTo.value : null),
        workRequestName: (workRequestName ? workRequestName.value : null),
        workRequestReferenceNum: (workRequestReferenceNum ? workRequestReferenceNum.value : null),
        code: (code ? code.value : null),
        submittedBy: (submittedBy ? submittedBy.value : null),
        verifiedBy: (verifiedBy ? verifiedBy.value : null),
        spectator: (spectators ? spectators.value : null)
      },
      (response) => {
          console.log('fetchWorkItems', 'findWorkItems', response);
          this.setState({ loading: false, workItems: response.data });
          this.storeInDataStore();
      }, (error) => {
        console.log('fetchWorkItems', 'findWorkItems', error);
        this.setState({ loading: false, workItems: [] });
      });
    }
    else {
      this.props.findWorkItemsByAssignee({
        page,
        pageSize,
        order,
        ascDesc,
        userName: auth.name,
        name: (name ? name.value : null),
        referenceNum: (referenceNum ? referenceNum.value : ''),
        status: (status ? status.value : null),
        progress: (progress ? progress.value : null),
        isChecked: (isChecked ? isChecked.value : null),
        isLocked: (isLocked ? isLocked.value : null),
        workRequestName: (workRequestName ? workRequestName.value : null),
        workRequestReferenceNum: (workRequestReferenceNum ? workRequestReferenceNum.value : null),
        code: (code ? code.value : null),
        submittedBy: (submittedBy ? submittedBy.value : null),
        verifiedBy: (verifiedBy ? verifiedBy.value : null)
      },
      (response) => {
        console.log('fetchWorkItems', 'findWorkItemsByAssignee', response);
        this.setState({ loading: false, workItems: response.data });
        this.storeInDataStore();
      }, (error) => {
        console.log('fetchWorkItems', 'findWorkItemsByAssignee', error);
        this.setState({ loading: false, workItems: [] });
      });
    }
  }

  initDataStore() {
    const jsonDataStore = localStorage.getItem(this.dataStoreKey);

    if (!jsonDataStore) {
      this.fetchWorkItems();
      return;
    }

    let dataStore = JSON.parse(jsonDataStore);
    let { page, pageSize, order, ascDesc, name, referenceNum, status, progress, isChecked, isLocked, assignedTo, workRequestName, workRequestReferenceNum, code, submittedBy, verifiedBy, expiresOn, spectators } = dataStore;

    if (moment().isAfter(moment(expiresOn), 'second')) {
        console.log('fetchWorkItems_expires', expiresOn, moment().toDate());
        this.fetchWorkItems();
        return
    }

    if (isChecked == undefined) {
      isChecked = '';
    }

    if (isLocked == undefined) {
      isLocked = '';
    }

    this.setState({ page, pageSize, order, ascDesc, name, referenceNum, status, progress, isChecked, isLocked, assignedTo, workRequestName, workRequestReferenceNum, code, submittedBy, verifiedBy, spectators }, () => this.fetchWorkItems());
  }

  onPageChange(pageIndex) {
    console.log('onPageIndex', pageIndex);
    this.setState({ page: pageIndex + 1 }, (prevState, props) => {
      this.fetchWorkItems();
    });
  }

  onPageSizeChange(pageSize, pageIndex) {
    console.log('onPageSizeChange', pageSize, pageIndex);
    this.setState({ page: pageIndex + 1, pageSize }, (prevState, props) => {
      this.fetchWorkItems();
    });
  }

  onSortedChange(newSorted, column, shiftKey) {
    console.log('onSortedChange', newSorted, column, shiftKey);
    const lastIndex = newSorted.length - 1;
    let order = newSorted[lastIndex].id;
    let ascDesc = newSorted[lastIndex].desc ? 'desc' : 'asc';
    this.setState({ order, ascDesc }, (prevState, props) => {
      this.fetchWorkItems();
    });
  }

  onFilteredChange(filtered, column) {
    console.log('onFilteredChange', filtered, column);
    if (this.filterTimer) clearTimeout(this.filterTimer);
    const status = filtered.find(f => f.id === 'status');
    const progress = filtered.find(f => f.id === 'progress');
    const isChecked = filtered.find(f => f.id === 'isChecked');
    const isLocked = filtered.find(f => f.id === 'isLocked');
    const name = filtered.find(f => f.id === 'name');
    const referenceNum = filtered.find(f => f.id === 'referenceNum');
    const assignedTo = filtered.find(f => f.id === 'assignedTo');
    const spectators = filtered.find(f => f.id === 'spectators');
    const workRequestName = filtered.find(f => f.id === 'workRequestName');
    const workRequestReferenceNum = filtered.find(f => f.id === 'workRequestReferenceNum');
    const code = filtered.find(f => f.id === 'code');
    const submittedBy = filtered.find(f => f.id === 'submittedBy');
    const verifiedBy = filtered.find(f => f.id === 'verifiedBy');
    this.setState({ status, progress, name, isChecked, isLocked, referenceNum, assignedTo, workRequestName, workRequestReferenceNum, code, submittedBy, verifiedBy, spectators }, () => {
      this.filterTimer = setTimeout(() => this.fetchWorkItems(), 300);
    });
  }

  storeInDataStore() {
    let { page, pageSize, order, ascDesc, name, referenceNum, status, progress, isChecked, isLocked, assignedTo, workRequestName, workRequestReferenceNum, code, submittedBy, verifiedBy, spectators } = this.state;
    if (localStorage.getItem(this.dataStoreKey)) localStorage.removeItem(this.dataStoreKey);
    let dataStore = {
      page, pageSize, order, ascDesc, name, referenceNum, status, progress, isChecked, isLocked, assignedTo, workRequestName, workRequestReferenceNum, code, submittedBy, verifiedBy, spectators,
      expiresOn: moment().add(30, 'm').toDate()
    };
    localStorage.setItem(this.dataStoreKey, JSON.stringify(dataStore));
   }

   isAssignee(workItem) {
     return workItem.assignees && workItem.assignees.length > 0 && workItem.assignees.filter(a => a.userName.toLowerCase() === auth.name.toLowerCase()).length > 0;
   }

  renderAllColumnView() {
    let columns = [
        {
          Header: 'Item',
          columns: [
            {
              Header: 'ID',
              accessor: 'referenceNum',
              Cell: row => (
                <NavLink to={`/requisition/item/${row.value}`} className="visited">
                    {row.value}
                </NavLink>
              )
            },
            {
              Header: 'Name',
              accessor: 'name',
            },
            {
              Header: 'Code',
              accessor: 'code',
            }
          ]
        },
        {
          Header: 'Request',
          columns: [
            {
              Header: 'Title',
              id: 'workRequestName',
              accessor: 'workRequest.name',
              minWidth: 250
            },
            {
              Header: 'PRF',
              id: 'workRequestReferenceNum',
              accessor: 'workRequest.referenceNum',
              Cell: row => {
                if (auth.hasAccess('request', 'admin')) {
                  return (
                    <NavLink to={`/requisition/${row.value}`} className="visited">
                      {row.value}
                    </NavLink>
                  );
                }
                else {
                   return <span>{row.value}</span>
                }
              }
            }
          ]
        },
        {
          Header: 'Status',
          accessor: 'status',
          id: 'status',
          Cell: row => this.renderStatus(row.value),
          Filter: ({ filter, onChange }) =>
              <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ''}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
        },
        {
          Header: 'Progress',
          accessor: 'progress',
          Cell: row => this.renderStatus(row.value),
          Filter: ({ filter, onChange }) =>
              <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ''}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="In_Progress">In Progress</option>
                <option value="Completed">Completed</option>
                <option value="Expired">Expired</option>
                <option value="Rejected">Rejected</option>
                <option value="Canceled">Canceled</option>
              </select>
         },
        //  {
        //   Header: 'Checked',
        //   accessor: 'isChecked',
        //   Cell: row => this.renderFlags(row.value),
        //   Filter: ({ filter, onChange }) =>
        //       <select
        //         onChange={event => onChange(event.target.value)}
        //         style={{ width: "100%" }}
        //         value={filter ? filter.value : ''}
        //       >
        //         <option value="">All</option>
        //         <option value="true">Yes</option>
        //         <option value="false">No</option>
        //       </select>
        //  },
        //  {
        //   Header: 'Locked',
        //   accessor: 'isLocked',
        //   Cell: row => this.renderFlags(row.value),
        //   Filter: ({ filter, onChange }) =>
        //       <select
        //         onChange={event => onChange(event.target.value)}
        //         style={{ width: "100%" }}
        //         value={filter ? filter.value : ''}
        //       >
        //         <option value="">All</option>
        //         <option value="true">Yes</option>
        //         <option value="false">No</option>
        //       </select>
        //  },
         {
           Header: 'Assigned To',
           id: 'assignedTo',
           sortable: false,
           minWidth: 200,
           accessor: 'assignees',
           Cell: row => {
              let assignees = [];
              for(let a of row.value) {
                assignees.push(a.userName);
              }
              return (<span>{assignees.join(', ')}</span>)
           }
         },
         {
          Header: 'View Only',
          id: 'spectators',
          sortable: false,
          minWidth: 200,
          accessor: 'spectators',
          Cell: row => {
             return (<span>{row.value.join(', ')}</span>)
          }
        },
         {
          Header: 'Submitted',
          columns: [
            {
              Header: 'By',
              accessor: 'submittedBy'
            },
            {
              Header: 'Date',
              filterable: false,
              accessor: 'submittedOn',
              Cell: row => (
                <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
              )
            }
          ]
        },
        {
          Header: 'Verified',
          columns: [
            {
              Header: 'By',
              accessor: 'verifiedBy'
            },
            {
              Header: 'Date',
              filterable: false,
              accessor: 'verifiedOn',
              Cell: row => (
                <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
              )
            }
          ]
        }
      ];

      return columns;
  }

  renderAssignedToMeColumnView() {
    let columns = [
        {
          Header: 'Item',
          columns: [
            {
              Header: 'ID',
              accessor: d => d.workItem.referenceNum,
              id: 'referenceNum',
              Cell: row => (
                <NavLink to={`/requisition/item/${row.value}`} className="visited">
                    {row.value}
                </NavLink>
              )
            },
            {
              Header: 'Name',
              accessor: d => d.workItem.name,
              id: 'name',
            },
            {
              Header: 'Code',
              accessor: d => d.workItem.code,
              id: 'code',
            }
          ]
        },
        {
          Header: 'Request',
          columns: [
            {
              Header: 'Title',
              id: 'workRequestName',
              accessor: d => d.workItem.workRequest.name,
              minWidth: 250
            },
            {
              Header: 'PRF',
              id: 'workRequestReferenceNum',
              accessor: d => d.workItem.workRequest.referenceNum,
              Cell: row => {
                if (auth.hasAccess('request', 'admin')) {
                  return (
                    <NavLink to={`/requisition/${row.value}`} className="visited">
                      {row.value}
                    </NavLink>
                  );
                }
                else {
                   return <span>{row.value}</span>
                }
              }
            }
          ]
        },
        {
          Header: 'Status',
          accessor: d => d.workItem.status,
          id: 'status',
          Cell: row => this.renderStatus(row.value),
          Filter: ({ filter, onChange }) =>
              <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ''}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
        },
        {
          Header: 'Progress',
          accessor: 'progress',
          Cell: row => this.renderStatus(row.value),
          Filter: ({ filter, onChange }) =>
              <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ''}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="In_Progress">In Progress</option>
                <option value="Completed">Completed</option>
                <option value="Expired">Expired</option>
                <option value="Rejected">Rejected</option>
                <option value="Canceled">Canceled</option>
              </select>
         },
         {
          Header: 'Remark',
          id: 'remarks',
          accessor: d => d.workItem.remarks,
          sortable: false,
          filterable: false,
          minWidth: 200
         },
         {
           Header: 'Assigned Date',
           filterable: false,
           id: 'assignedOn',
           accessor: d => d.createdOn,
           Cell: row => (
             <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
           )
         },
         {
           Header: 'Verified Date',
           filterable: false,
           id: 'verifiedOn',
           accessor: d => d.workItem.verifiedOn,
           Cell: row => (
             <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
           )
         },
         {
          Header: 'Submitted',
          columns: [
            {
              Header: 'By',
              accessor: d => d.workItem.submittedBy,
              id: 'submittedBy'
            },
            {
              Header: 'Date',
              filterable: false,
              accessor: d => d.workItem.submittedOn,
              id: 'submittedOn',
              Cell: row => (
                <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
              )
            }
          ]
        }
      ];

      return columns;
  }

  renderViewOnlyColumnView() {
    let columns = [
        {
          Header: 'Item',
          columns: [
            {
              Header: 'ID',
              accessor: d => d.referenceNum,
              id: 'referenceNum',
              Cell: row => (
                <NavLink to={`/requisition/item/${row.value}`} className="visited">
                    {row.value}
                </NavLink>
              )
            },
            {
              Header: 'Name',
              accessor: d => d.name,
              id: 'name',
            },
            {
              Header: 'Code',
              accessor: d => d.code,
              id: 'code',
            }
          ]
        },
        {
          Header: 'Request',
          columns: [
            {
              Header: 'Title',
              id: 'workRequestName',
              accessor: d => d.workRequest.name,
              minWidth: 250
            },
            {
              Header: 'PRF',
              id: 'workRequestReferenceNum',
              accessor: d => d.workRequest.referenceNum,
              Cell: row => {
                if (auth.hasAccess('request', 'admin')) {
                  return (
                    <NavLink to={`/requisition/${row.value}`} className="visited">
                      {row.value}
                    </NavLink>
                  );
                }
                else {
                   return <span>{row.value}</span>
                }
              }
            }
          ]
        },
        {
          Header: 'Status',
          accessor: d => d.status,
          id: 'status',
          Cell: row => this.renderStatus(row.value),
          Filter: ({ filter, onChange }) =>
              <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ''}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
        },
        {
          Header: 'Progress',
          accessor: 'progress',
          Cell: row => this.renderStatus(row.value),
          Filter: ({ filter, onChange }) =>
              <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ''}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="In_Progress">In Progress</option>
                <option value="Completed">Completed</option>
                <option value="Expired">Expired</option>
                <option value="Rejected">Rejected</option>
                <option value="Canceled">Canceled</option>
              </select>
         },
         {
          Header: 'Remark',
          id: 'remarks',
          accessor: d => d.remarks,
          sortable: false,
          filterable: false,
          minWidth: 200
         },
         {
           Header: 'Assigned Date',
           filterable: false,
           id: 'assignedOn',
           accessor: d => d.createdOn,
           Cell: row => (
             <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
           )
         },
         {
           Header: 'Verified Date',
           filterable: false,
           id: 'verifiedOn',
           accessor: d => d.verifiedOn,
           Cell: row => (
             <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
           )
         },
         {
          Header: 'Submitted',
          columns: [
            {
              Header: 'By',
              accessor: d => d.submittedBy,
              id: 'submittedBy'
            },
            {
              Header: 'Date',
              filterable: false,
              accessor: d => d.submittedOn,
              id: 'submittedOn',
              Cell: row => (
                <span>{row.value ? moment(row.value).format('DD/MM/YYYY') : ''}</span>
              )
            }
          ]
        }
      ];

      return columns;
  }


  subColumns() {
    return [
      {
        Header: 'Synced Reference Num',
        accessor: 'referenceNum',
        id: 'referenceNum',
        Cell: row => (
          <span className="d-block text-center">
            {(auth.hasAccess('purchase', 'read', 'IMS') || auth.hasAccess('adjustment', 'read', 'IMS') || auth.hasAccess('undertake', 'read', 'IMS')) &&
               <a href={row.value} target="_blank">{row.value}</a>
            }
            {(!auth.hasAccess('purchase', 'read', 'IMS') && !auth.hasAccess('adjustment', 'read', 'IMS') && !auth.hasAccess('undertake', 'read', 'IMS')) &&
              <span>{row.value}</span>
            }
          </span>
        )
      },
      {
        Header: 'Status',
        accessor: 'status',
        id: 'status',
        maxWidth: 100,
        Cell: row => this.renderStatus(row.value)
      },
      {
        Header: 'Checked',
        id: 'hasChecked',
        accessor: 'hasChecked',
        maxWidth: 100,
        Cell: row => this.renderFlags(row.value)
      },
      {
        Header: 'Locked',
        id: 'isLocked',
        accessor: 'isLocked',
        maxWidth: 100,
        Cell: row => this.renderFlags(row.value)
      },
      {
        Header: 'Wrong',
        id: 'isWrong',
        accessor: 'isWrong',
        maxWidth: 100,
        Cell: row => this.renderFlags(row.value)
      }
    ];
  }

  renderStatus(value) {
    return (
      <span>
       <span className={`d-inline-block rounded-circle mr-2 ${
         value === 'Approved' || value === 'Completed' || value === 'Closed' ? 'bg-success'
          : value === 'Rejected' || value === 'Rejected' ? 'bg-danger'
          : value === 'In_Progress' ? 'bg-primary'
          : value === 'Canceled' ? 'bg-warning'
          : 'bg-secondary'
       }`} style={{
         width: '8px', height: '8px'
       }}>
       </span>
       {value.replace('_', ' ')}
     </span>
    );
  }

  renderFlags(value) {
    return (
      <span>
       <span className={`d-inline-block rounded-circle mr-2 ${
         value ? 'bg-success' : 'bg-danger'
       }`} style={{
         width: '8px', height: '8px'
       }}>
       </span>
       {value ? 'Yes' : 'No'}
     </span>
    );
  }

  renderAlert() {
    return (
      <div>
        {this.state.alert.display &&
          <Alert type={this.state.alert.type} icon={this.state.alert.icon} isDismissible>
            {this.state.alert.message}
          </Alert>
        }
      </div>
    );
  }

  render ()  {
    const { loading, type, workItems, page, pageSize, order, ascDesc, name, referenceNum, status, progress, isChecked, isLocked, assignedTo, workRequestName, workRequestReferenceNum, code, submittedBy, verifiedBy, spectators } = this.state;
    const { pagination } = workItems;
    const { totalPages } = pagination ? pagination : { totalPages: 1 };

    let filtered = [];
    let sorted = [];

    if (order && ascDesc) sorted.push({ id: order, desc: ascDesc === 'desc' });
    if (name) filtered.push(name);
    if (referenceNum) filtered.push(referenceNum);
    if (status) filtered.push(status);
    if (progress) filtered.push(progress);
    if (isChecked) filtered.push(isChecked);
    if (isLocked) filtered.push(isLocked);
    if (assignedTo) filtered.push(assignedTo);
    if (workRequestName) filtered.push(workRequestName);
    if (workRequestReferenceNum) filtered.push(workRequestReferenceNum);
    if (code) filtered.push(code);
    if (submittedBy) filtered.push(submittedBy);
    if (verifiedBy) filtered.push(verifiedBy);
    if (spectators) filtered.push(spectators);

    let pageTitle = '';
    let columns = [];
    switch(type) {
      case ItemListingPageTypes.ASSIGNED_TO_ME:
        pageTitle = 'Assigned To Me';
        columns = this.renderAssignedToMeColumnView();
        break;
      case ItemListingPageTypes.VIEW_ONLY:
        pageTitle = 'View Only';
        columns = this.renderAllColumnView();
        break;
      default:
        pageTitle = 'All';
        columns = this.renderAllColumnView();
        break;
    }

    return (
        <SiteWrapper>
            <Page.Content>
              {this.renderAlert()}
              <Card>
                <Card.Header>
                  <Card.Title>
                    {pageTitle}
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <ReactTable
                    data={workItems.items}
                    columns={columns}
                    loading={loading}
                    page={page ? page - 1 : 0}
                    pages={totalPages}
                    pageSize={pageSize ? pageSize : 50}
                    filtered={filtered}
                    sorted={sorted}
                    showPaginationTop
                    showPaginationBottom
                    filterable
                    manual
                    className="-striped -highlight"
                    onPageChange={this.onPageChange} // Called when the page index is changed by the user
                    onPageSizeChange={this.onPageSizeChange} // Called when the pageSize is changed by the user. The resolve page is also sent to maintain approximate position in the data
                    onSortedChange={this.onSortedChange} // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, `column` will be an array of columns
                    onFilteredChange={this.onFilteredChange} // Called when a user enters a value into a filter input field or the value passed to the onFiltersChange handler by the Filter option.
                    SubComponent={row => {
                      const { references } = row.original;
                      return (
                         <ReactTable
                           data={references}
                           columns={this.subColumns()}
                           defaultPageSize={references ? references.length : 0}
                           showPagination={false}
                           className="table-secondary table-sm table-striped"
                         />
                      );
                    }}
                  />
                </Card.Body>
              </Card>
            </Page.Content>
        </SiteWrapper>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({  findWorkItems, findWorkItemsByAssignee }, dispatch)
}

function mapStateToProps(props) {
  return props;
}

export default connect(mapStateToProps, mapDispatchToProps)(RequisitionItemPage)



// WEBPACK FOOTER //
// ./src/requisition/item.react.js